import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Coque modal responsive : sur mobile, panneau type « sheet » (bas de l’écran),
 * hauteur limitée (dvh + safe areas), coins supérieurs arrondis ; sur sm+ centré.
 * Porté dans `document.body` pour passer au-dessus de la tab bar membre.
 *
 * @param {React.ReactNode} children
 * @param {() => void} [onBackdropClick] — si défini, clic sur le fond déclenche l’action (ex. fermer).
 * @param {string} [maxWidthClass] — ex. max-w-2xl
 * @param {string} [zClass] — ex. z-[100]
 * @param {string} [panelClassName] — classes additionnelles sur le panneau
 * @param {boolean} [showHandle=true] — poignée de sheet mobile
 */
export default function ModalShell({
  children,
  onBackdropClick,
  maxWidthClass = 'max-w-lg',
  zClass = 'z-[100]',
  panelClassName = '',
  showHandle = true,
}) {
  const node = (
    <div
      className={`mm-modal-backdrop fixed inset-0 flex ${zClass} items-end justify-center pt-[env(safe-area-inset-top,0px)] sm:items-center sm:p-4 sm:pt-4`}
      role="presentation"
      onClick={onBackdropClick}
    >
      <div
        className={`mm-modal-panel relative flex max-h-[min(92dvh,calc(100dvh-env(safe-area-inset-top,0px)-12px))] w-full flex-col overflow-hidden sm:max-h-[90vh] sm:mb-0 ${maxWidthClass} ${panelClassName}`}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        {showHandle ? (
          <div className="flex shrink-0 justify-center pt-2 sm:hidden" aria-hidden>
            <span className="mm-modal-handle" />
          </div>
        ) : null}
        {children}
      </div>
    </div>
  );

  if (typeof document === 'undefined') return node;
  return createPortal(node, document.body);
}
